/* The Pomiary plot's own overlays: the selection painted over the line, and the two handles that
 * move it. KANON `pomiary-klienta-2026-09-18`, direction D.
 *
 * ── Why the ember hues arrive through `color` ────────────────────────────────────────────────
 * An SVG `<stop>` takes a colour, not a `linear-gradient()`, so `--accent-grad` cannot be read
 * there. The three stops of the same ramp are `--accent-grad-from|mid|to` in `tokens/colors.css`,
 * and each `<stop>` reads its own through `currentColor` — which keeps the hue in a stylesheet,
 * where Stylelint can see it, instead of as a hex in a `.tsx`. The precedent is the roster table's
 * wellbeing spark.
 *
 * Nothing here has a shadow, a blur or a filter. The accent is a fill and a stroke. */

.emberFrom {
  color: var(--accent-grad-from);
}

.emberMid {
  color: var(--accent-grad-mid);
}

.emberTo {
  color: var(--accent-grad-to);
}

/* The wash under the selected stretch — the flat accent, faded to nothing at the baseline. Its two
 * opacities are on the stops themselves, because a stop's alpha is not a colour. */
.emberWash {
  color: var(--accent);
}

/* The trend line, drawn here because `ReadoutChart` is drawing the RAW readings as dots. Neutral
 * ink: the ember is spent on the selection and nowhere else on this plot. */
.trendLine {
  fill: none;
  stroke: var(--chart-series-neutral);
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Outside A..B the line recedes behind the card's own ground. Not a tint — the same surface the
 * card is painted in, so nothing outside the selection changes hue. */
.veil {
  fill: var(--bg-card);
  fill-opacity: 0.62;
}

.selectionStroke {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.projectionLine {
  fill: none;
  stroke: var(--chart-series-neutral);
  stroke-dasharray: 3 5;
  stroke-linecap: round;
  stroke-width: var(--border-focus);
  opacity: 0.7;
}

.projectionLabel {
  font-size: var(--fs-micro-label);
  font-weight: var(--fw-semibold);
  fill: var(--text-3);
}

/* The overlay arrives after the series has swept in — opacity only, and never under a reduced
 * motion preference, which is passed in as a parameter rather than read from a media block. */
.overlayIn {
  animation: two-dates-overlay-in var(--dur-slow) var(--ease-default) both;
}

@keyframes two-dates-overlay-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

